import React, { useState, useEffect, useRef, useMemo } from 'react'
import removeParentheses from '../../../utils/removeParenths'
import ReactHtmlParser from 'react-html-parser'
import styled from 'styled-components'
import Text from '../../atoms/Text/Text'
import media from 'styled-media-query'
import IconCalendar from '../../IconCalendar/IconCalendar'
import IconBriefcase from '../../IconBriefcase/IconBriefcase'
import IconLocation from '../../IconLocation/IconLocation'
import IconPerson from '../../IconPerson/IconPerson'
import StarRatings from '../../StarRatings/StarRatings'
import TextTruncate from 'react-text-truncate'

const Block = styled.div`
  ${(props) =>
    props.divider
      ? `

`
      : ''}

  width: 100%;
  justify-content: space-between;
  ${media.lessThan('medium')`
  flex-wrap: wrap;
  `}
`
const Column = styled.div`
  ${media.lessThan('medium')`
width: 100%;

`}
`
const Flex = styled.div`
  display: flex;
  align-items: center;
`
const Style = styled.div`
  position: relative;
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  border: 1px solid #e1e7ef;
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 24px;

  .title {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #162941;
    margin: 16px 0;
  }

  .meta-text {
    color: #677d95;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
  }

  .list {
    padding-bottom: 20px;
    img {
      margin: 0;
      display: inline-block;
      margin-right: 10px;
    }
    p {
      display: inline-block;
    }
    li {
      margin-bottom: 5px;
    }
  }
  .body {
    width: 80%;
    .response {
      margin-bottom: 20px;
      padding: 20px 30px;
      width: 100%;
      background: #f7f7f7;
      .response-body {
        font-size: 16px;
        color: #000000;
        letter-spacing: 0.5px;
        line-height: 25px;
      }
      img {
        border-radius: 50%;
        display: inline-block;
      }
      .header {
        margin-bottom: 0;
        display: inline-block;
        font-size: 16px;
        color: #000000;
        letter-spacing: 0.5px;
        line-height: 50px;
        margin-left: 20px;
      }
    }
    .date {
      display: inline-block;
      font-size: 16px;
      color: #878787;
      letter-spacing: 0.5px;
      text-align: right;
      line-height: 25px;
      ${media.lessThan('medium')`
        position: absolute;
        top: 47px;
        right: 0;

`}
    }

    .stars {
      margin-bottom: 0;
      img {
        width: 140px;
        margin-bottom: 0;
      }
    }
    width: 100%;
    ${media.lessThan('medium')`
  width: 100%;
  `}
    .agreements {
      .recommend {
        margin-top: 10px;
        img {
          display: inline;
          margin-right: 5px;
          vertical-align: top;
        }
      }
    }
    .ratings {
      padding-top: 20px;
      padding-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      & > div {
        margin-bottom: 20px;
        width: 50%;
        img {
          margin-top: 5px;
        }
      }
    }
    .content {
      .trunc {
        p {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          overflow-wrap: break-word;
          word-break: break-word;
        }
      }
      .user-review {
        overflow: hidden;
      }

      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #162941;

      ${media.lessThan('medium')`
    width: 100%;
  `}
    }
  }
  .info {
    ${media.lessThan('medium')`
    width: 100%;
  `}
    .stars {
      display: none;
      img {
        width: 140px;
      }
    }
  }
  .secondary-info {
    & > div {
      margin-bottom: 4px;
      font-size: 13px;
      color: #000000;
      letter-spacing: 0.46px;
      line-height: 21px;
    }
    p {
      font-size: 14px;
    }
  }
  .more {
    cursor: pointer;
    font-weight: 600;
  }
  .reply {
    padding: 16px;
    background: #f8f9fb;
    border-radius: 16px;
    margin-top: 24px;
  }
  .reply-title {
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #162941;
  }
  .pill {
    height: 21px;
    background: #ebeff4;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    margin-right: 8px;
    color: #383838;
    font-size: 12px;
  }
`

const CenterReview = ({ title, overall, data, image, ...rest }) => {
  const ref = useRef()
  const [id] = useState(Math.random().toString())
  const [viewMore, setViewMore] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [showAllCondition, setShowAllCondition] = useState(false)
  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    setIsMobile(window.matchMedia('(max-width: 767px)').matches)
  }, [])

  return (
    <Style>
      <Block {...rest}>
        <Column className="info">
          <div>
            <div className="">
              <StarRatings
                rating={data.overall_star}
                starRatedColor="#F1C249"
                starSpacing="2.5px"
                numberOfStars={5}
                uniqueKey={data.id}
                starDimension="16px"
              />
            </div>
            <Text className="title">{data.name ? data.name : 'Anonymous'}</Text>
            {data.stay_length && (
              <Flex>
                <div className="text-gray-700">
                  <IconCalendar />
                </div>
                <p className="meta-text ml-1">
                  {data.year && data.year !== 'NaN' && `${data.year}`}{' '}
                  {data.stay_length && `(${data.stay_length})`}{' '}
                  {data?.submit_date && `• Reviewed ${data?.submit_date}`}
                </p>
              </Flex>
            )}
            <Flex className="mt-2 flex-wrap gap-y-2">
              {data.reviewer_type && (
                <Flex className="!items-start">
                  <div className="mt-[2px] text-gray-700">
                    <IconPerson />
                  </div>
                  <p className="meta-text ml-1 mr-3">{data.reviewer_type}</p>
                </Flex>
              )}
              {data.occupation && (
                <Flex className="!items-start">
                  <div className="mt-[2px] text-gray-700">
                    <IconBriefcase className="mt-[1px]" />
                  </div>
                  <p className="meta-text ml-1 mr-[12px]">{data.occupation}</p>
                </Flex>
              )}
              {data.location && (
                <Flex className="!items-start">
                  <div
                    style={{ color: '#677D95' }}
                    className="mt-[2px] text-gray-700"
                  >
                    <IconLocation className="h-[16px] mt-[1p]" />
                  </div>
                  <p className="meta-text ml-1">{data.location}</p>
                </Flex>
              )}
            </Flex>
            {data.conditions_treated?.length > 0 &&
              data.reviewer_type !== 'Referring Professional' && (
                <Flex className="flex-wrap gap-y-2 mt-4">
                  {(showAllCondition
                    ? data.conditions_treated
                    : data.conditions_treated.slice(0, 3)
                  ).map((item, i) => (
                    <div
                      key={i}
                      className="pill"
                    >
                      {removeParentheses(item)}
                    </div>
                  ))}
                  {data.conditions_treated.length > 3 && !showAllCondition && (
                    <div
                      className="pill cursor-pointer"
                      onClick={() => setShowAllCondition(true)}
                    >
                      +{data.conditions_treated?.length - 3}
                    </div>
                  )}
                </Flex>
              )}
          </div>
        </Column>
        <Column className="body mt-6">
          <div className="content review-content">
            <div>
              {showMore ? (
                <p
                  className="user-review trunc"
                  id={`user-review-${id}`}
                >
                  {ReactHtmlParser(
                    data.review_body.replace('<p>', '').replace('</p>', '')
                  )}
                  <span> </span>
                  <span
                    className="more"
                    onClick={() => {
                      setShowMore(false)
                    }}
                  >
                    {' '}
                    Less
                  </span>
                </p>
              ) : (
                <TextTruncate
                  ref={ref}
                  line={showMore ? 0 : isMobile ? 5 : 3}
                  element="span"
                  truncateText="…"
                  text={data.review_body.replace('<p>', '').replace('</p>', '')}
                  textTruncateChild={
                    <span
                      className="more"
                      onClick={() => {
                        setShowMore(true)
                      }}
                    >
                      More
                    </span>
                  }
                />
              )}
            </div>
            {data.response && (
              <div className="reply">
                <div>
                  <p className="reply-title">{data.center}</p>
                  {viewMore ? (
                    <p
                      className="user-review trunc"
                      id={`user-review-${id}`}
                    >
                      {ReactHtmlParser(
                        data.response.replace('<p>', '').replace('</p>', '')
                      )}
                      <span> </span>
                      <span
                        className="more"
                        onClick={() => {
                          setViewMore(false)
                        }}
                      >
                        {' '}
                        Less
                      </span>
                    </p>
                  ) : (
                    <TextTruncate
                      ref={ref}
                      line={viewMore ? 0 : 3}
                      element="span"
                      truncateText="…"
                      text={data.response
                        .replace('<p>', '')
                        .replace('</p>', '')}
                      textTruncateChild={
                        <span
                          className="more"
                          onClick={() => {
                            setViewMore(true)
                          }}
                        >
                          More
                        </span>
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Column>
      </Block>
    </Style>
  )
}
export default CenterReview
